import React, { Fragment, useState } from 'react';
import { Btn } from '../../../../AbstractElements';
import { Col, Row } from 'reactstrap';
import Filter from './Filter';
import Location from './Location';
import JobTitleClass from './JobTitle';
import Industry from './Industry';
import SkillClass from './Skill';

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <Col className='col-xxl-3 col-xl-4 box-col-30'>
        <div className='job-sidebar'>
          <Btn onClick={(e) => setOpen(!open)} color='primary' className='job-toggle'>
            job filter
          </Btn>
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${open ? 'open' : ''}`}>
            <div className='default-according style-1 faq-accordion job-accordion' id='accordionoc'>
              <Row>
                <Filter />
                <Location />
                <JobTitleClass />
                <Industry />
                <SkillClass />
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default Sidebar;
